export default "__VITE_ASSET__CLXby8WS__"